import React from "react";

const Divider = ({ title }) => {
  return (
    <div className="flex items-center justify-center my-6">
      <div className="flex-grow border-t border-accent" />
      <span className="mx-4 text-xs sm:text-sm font-semibold text-muted uppercase tracking-widest">
        {title}
      </span>
      <div className="flex-grow border-t border-accent" />
    </div>
  );
};

export default Divider;